import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import MModal from '../../../common/m-modal/MModal';
import {setActiveRole} from "../../../../store/reducers/userSlice";

//import { setActiveRole } from '../../../../store/reducers/userSlice';

const ChooseRoleModal = ({
    isChooseRoleModal,
    setIsChooseRoleModal
}) => {

    const {t} = useTranslation();
    const roles = ['expert_teacher', 'expert_student']

   const dispatch=useDispatch()
    return (
        <MModal
            active={isChooseRoleModal}
            setActive={setIsChooseRoleModal}
        >
            <div className="flex flex-col w-96">
                <h5 className="text-xl font-semibold mx-auto my-3 mb-8">
                    {t('general.header.chooseRoleModal.title')}
                </h5>
                {roles.map(role => (
                    <p key={role}
                       className="font-medium text-base text-center border-solid border-2 mb-4 rounded-lg p-2 cursor-pointer"
                       onClick={()=>{
                           dispatch(setActiveRole(role))
                           const user = JSON.parse(localStorage.getItem('user'))
                           user.activeRole = role
                           localStorage.setItem('user',JSON.stringify(user))
                           setIsChooseRoleModal(false)
                       }}
                    >
                        {t(`general.header.chooseRoleModal.roles.${role}`)}
                    </p>
                ))}
                <p
                    className="font-medium text-sm text-center text-main-color mt-6 cursor-pointer"
                    onClick={()=>setIsChooseRoleModal(false)}
                >
                    {t('general.header.chooseRoleModal.cancel')}
                </p>
            </div>
        </MModal>
    );
};
export default ChooseRoleModal;
